import { createApp, type Plugin } from 'vue';
import { createPinia } from 'pinia';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { App, getRouter, vuetifyOptions, type IConfiguration } from '@fondationcss/ui';
import { getCustomRoutes } from './routes';
import { menus } from './sidebar-items';
import { WikiPlugin } from '@fondationcss/wiki'
import { i18n } from './i18n';

import 'vuetify/styles';
import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';
import '@fondationcss/ui/dist/style.css';
import '@fondationcss/wiki/dist/style.css';
import '@fondationcss/markdown/dist/style.css';
import '@fondationcss/markdown/dist/markdown.css';
import "@/styles.css";
import './hljs-theme.css';


const config = {
  AppName: 'Osmos',
  SiteNameShort: 'Osmos',
  SiteNameLong: 'Byrnu Osmos',
  LogoLine1: 'Byrnu',
  LogoLine2: 'Osmos',
  Copyright: 'Copyright © 2026',
  Menus: menus,
  EnableAccessRequestButton: false,
  DefaultLayout: 'byrnu-red-app',
  ThemeColor: '#3460a8',
  Logo: '/images/osmos.svg',
  SiteLogo: '/images/osmos.svg',
  SiteLogoAlt: '/images/osmos-alt.svg',
  HideLoginLogo: true,
} as IConfiguration;

const vuetify = createVuetify({
  components,
  directives,
  ...vuetifyOptions
})
const app = createApp(App);
const router = getRouter(getCustomRoutes);
app.provide('config', config)
app.provide('sdkOptions', { apiUrl: import.meta.env.VITE_API_URL })
app.use(vuetify);
app.component('font-awesome-icon', FontAwesomeIcon)
library.add(fas)
library.add(far)
app.use(createPinia());
app.use(PerfectScrollbarPlugin);
app.use(i18n);
app.use(router);
// Type assertion needed due to Vue 3.5+ stricter Plugin generic constraints
app.use(WikiPlugin as unknown as Plugin, { router })
app.mount('#app');
